import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export function AuthCard({ title, testid, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6" data-testid={testid}>
      <div className="w-full max-w-md border border-border p-8 lg:p-10 bg-white">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-5 w-5 bg-execution" />
          <span className="font-heading text-lg font-bold tracking-tight">Nexra</span>
        </div>
        <h2 className="font-heading text-2xl font-semibold tracking-tight mb-6">{title}</h2>
        {children}
      </div>
    </div>
  );
}

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords don't match.");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthCard title="Choose a new password" testid="admin-reset-page">
      {done ? (
        <p className="text-sm mb-6" data-testid="admin-reset-success">Your password has been updated. You can now sign in.</p>
      ) : !token ? (
        <p className="text-sm text-destructive mb-6" data-testid="admin-reset-missing-token">This reset link is incomplete. Please request a new one.</p>
      ) : (
        <form onSubmit={onSubmit} data-testid="admin-reset-form">
          <label className="block mb-5">
            <span className="block text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mb-2">New password</span>
            <input type="password" required autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-swiss" data-testid="admin-reset-password" />
          </label>
          <label className="block mb-5">
            <span className="block text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mb-2">Confirm password</span>
            <input type="password" required autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-swiss" data-testid="admin-reset-confirm" />
          </label>
          {error && <div className="mb-5 text-sm text-destructive" data-testid="admin-reset-error">{error}</div>}
          <button type="submit" disabled={submitting} className="btn-primary w-full disabled:opacity-60" data-testid="admin-reset-submit">
            {submitting ? "Saving..." : "Update password"}
          </button>
        </form>
      )}
      <Link to="/admin/login" className="mt-6 inline-block text-xs text-execution hover:underline" data-testid="admin-reset-back-login">
        Back to sign in
      </Link>
    </AuthCard>
  );
}
